// Toggles the transparent header to a solid state once the page is scrolled
// past a small threshold. Paired with component-header-transparent.css and the
// header setting `transparent_on_top`.
(function () {
  var header = document.querySelector('.header-wrapper--transparent');
  if (!header) return;

  var THRESHOLD = 50; // px scrolled before the header becomes solid
  var ticking = false;

  function update() {
    if (window.scrollY > THRESHOLD) {
      header.classList.add('is-solid');
    } else {
      header.classList.remove('is-solid');
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  // In the theme editor, keep it solid so merchants can always read the header.
  if (window.Shopify && window.Shopify.designMode) {
    header.classList.add('is-solid');
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();
